/**
 * ResumeMetric - GPA Calculator
 * Weighted average GPA with multiple grading scales.
 * @module tools/gpaCalculator
 */

const GRADE_SCALES = {
    us4: { 'A+': 4.0, 'A': 4.0, 'A-': 3.7, 'B+': 3.3, 'B': 3.0, 'B-': 2.7, 'C+': 2.3, 'C': 2.0, 'C-': 1.7, 'D+': 1.3, 'D': 1.0, 'D-': 0.7, 'F': 0.0 },
    us5: { 'A+': 5.0, 'A': 5.0, 'A-': 4.7, 'B+': 4.3, 'B': 4.0, 'B-': 3.7, 'C+': 3.3, 'C': 3.0, 'C-': 2.7, 'D+': 2.3, 'D': 2.0, 'D-': 1.7, 'F': 0.0 }
};

export function getGradeOptions(scale) {
    return Object.keys(GRADE_SCALES[scale] || GRADE_SCALES.us4);
}

export function calculateGPA(courses, scale = 'us4') {
    const gradeMap = GRADE_SCALES[scale] || GRADE_SCALES.us4;

    const valid = courses.filter(c => c.grade && c.credits > 0 && gradeMap[c.grade] !== undefined);
    if (valid.length === 0) return null;

    let totalPoints = 0;
    let totalCredits = 0;

    const breakdown = valid.map(c => {
        const points = gradeMap[c.grade];
        const qualityPoints = points * c.credits;
        totalPoints += qualityPoints;
        totalCredits += c.credits;
        return { name: c.name || 'Unnamed', grade: c.grade, credits: c.credits, points, qualityPoints };
    });

    const gpa = totalPoints / totalCredits;
    const maxGPA = Math.max(...Object.values(gradeMap));

    return {
        gpa: Math.round(gpa * 1000) / 1000,
        totalCredits,
        totalQualityPoints: Math.round(totalPoints * 100) / 100,
        maxGPA,
        percentage: ((gpa / maxGPA) * 100).toFixed(1),
        courses: breakdown
    };
}
